export default __webpack_public_path__ + "static/media/151-file-storage.c683328f.png";